`<template>
  <div>
      <div class="card d-md-inline-flex flex-lg-row h-100 my-3 p-0 b-0 rounded-0 box-shadow">
          <p v-if="!isArchived"
             class="card-text bg-dark">
              {{ fakeIndex }}
          </p>
          <div class="drag-handle d-none d-lg-block handle" data-toggle="tooltip" data-placement="top" title="Sort Image">

              <i class=" fas fa-arrows-alt align-items-center position-absolute"></i>
          </div>

          <input type="checkbox" v-if="!isArchived"
                 class="t-0 r-0 position-absolute ul-checkbox d-lg-block"
                 :value="image.id"
                 @change="selectImage(image)"
                 :checked="isChecked"
                 
                 />
          <div class="card-header border-0 p-3 pl-lg-5 bg-white">
              
              <div class="text-center position-relative">
                  <div>
                      <img :src="getImageSource(image)" class="card-image" />

                  </div>
              </div>
              <div class="d-sm-flex d-lg-none justify-content-center align-items-center text-center mt-3">
                  <button v-if="isArchived"
                          type="button"
                          class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                          @click="restoreImage(image)">
                      Restore
                  </button>
                  <button v-if="!isArchived"
                          type="button"
                          data-toggle="modal"
                          :data-target="'#' + modalTargetId"
                          data-backdrop="true"
                          class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                          @click="showModal = true">
                      Edit
                  </button>

                  <a v-if="!isArchived && !isBlob" class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                     target="_blank"
                     :href="image.BlobImageUrl"
                     @click.prevent="downloadImage(image)"
                     data-toggle="tooltip"
                     data-placement="top"
                     :disabled="isBlob"
                     title="Download">
                      Download
                  </a>
                  <a v-else href="#" class="btn btn-link btn-no-hover-effect pe-none text-decoration-none font-weight-bold text-uppercase text-muted pl-0"
                     @click.prevent=""
                     >
                      <i class="fas fa-download"></i> Download
                  </a>
                  <button v-if="!isArchived"
                          type="button"
                          class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                          @click="deleteImage(image)">
                      Delete
                  </button>
              </div>
          </div>
          <hr class="d-sm-flex d-lg-none my-2 mx-0" />

          <div class="card-body align-self-lg-center">

              <small v-if="isArchived" class="text-muted">Archived {{ archiveLength }}</small>
              <div class="d-none d-md-none d-lg-flex align-items-center pb-3">
                  <button v-if="!isArchived && !holdDelete"
                          type="button"
                          data-toggle="modal"
                          :data-target="'#' + modalTargetId"
                          data-backdrop="true"
                          class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                          @click="showModal = true">
                      <i class="fa fa-edit"></i> Edit
                  </button>
                  <a v-else href="" class="btn btn-link btn-no-hover-effect text-decoration-none pe-none font-weight-bold text-uppercase text-muted pl-0"
                     @click.prevent="">
                      <i class="fa fa-edit"></i> Edit
                  </a>
                  <a v-if="!isArchived && !isBlob && !holdDelete" class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                     target="_blank"
                     :href="image.BlobImageUrl"
                     @click.prevent="downloadImage(image)"
                     data-toggle="tooltip"
                     data-placement="top"
                     title="Download">
                      <i class="fas fa-download"></i> Download
                  </a>
                  <a v-else href="" class="btn btn-link btn-no-hover-effect text-decoration-none pe-none font-weight-bold text-uppercase text-muted pl-0"
                     @click.prevent="">
                      <i class="fas fa-download"></i> Download
                  </a>
                  <span v-if="!holdDelete">
                      <button v-if="!isArchived"
                              type="button"
                              class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                              @click="deleteImage(image)">
                          <i class="fa fa-trash"></i> Delete
                      </button>
                  </span>
                  <span v-else>

                      <span class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-muted pl-0" title="You must save before deleting items.">
                          <i class="fa fa-trash"></i> Delete
                      </span>

                  </span>



                  <button v-if="isArchived"
                          type="button"
                          class="btn btn-link btn-no-hover-effect text-decoration-none font-weight-bold text-uppercase text-dark pl-0"
                          @click="restoreImage(image)">
                      Restore
                  </button>
                  <transition name="fade">
                      <span key="1" v-if="loading">
                          <i class="fas fa-circle-notch fa-spin"></i>
                      </span>

                  </transition>

              </div>
              <div class="d-flex align-items-center justify-content-between">
                  <small v-if="!isBlob" class="text-muted">Stock: {{ stockNumber }}</small>
                  
              </div>
          </div>
      </div>
    <PhotoEditor
      :openModal="showModal"
      @modal="showModal = $event"
      :image="image"
      @updateImagePreview="displayCroppedImage"
      @edit-save-start="$emit('edit-save-start')"
      @edit-save-end="$emit('edit-save-end')"
    />
  </div>
</template>


<script>
import PhotoEditor from "@/components/PhotoEditor.vue";
import UploaderMixins from "../mixins/UploaderMixins.js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import axios from "axios";
//import { saveAs } from "file-saver";

export default {
  name: "ImageCard",
  mixins: [UploaderMixins],
  components: {
    PhotoEditor,
  },
  props: {
    image: {
      type: Object,
      default: null,
    },
    selectedMachine: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    bulkSelect: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isArchived: {
      type: Boolean,
      },
      unsavedHold: {
          type:Boolean
      }
  },
  data() {
    return {
      showModal: false,
        croppedImage: "",
      isChecked:false
    };
  },
  computed: {
    fakeIndex() {
      return this.index + 1;
      },
      isBlob() {
          if (this.image.blob) {
              return true;
          }
          return false;
      },
      holdDelete() {
          return this.unsavedHold;
      },
    stockNumber() {
      return this.selectedMachine
        ? this.selectedMachine.StockNumber
        : this.image.StockNumber;
    },
    archiveLength() {
      dayjs.extend(relativeTime);
      var now = dayjs();
      const imageDeleted = dayjs(this.image.DateDeletedOn);
      return imageDeleted != now ? imageDeleted.from(now) : now;
    },
    // Bug #58 fix: Each ImageCard instantiates its own PhotoEditor, which
    // originally rendered a modal with the static id "image-editor". When
    // many cards were present, Bootstrap's data-toggle lookup could resolve
    // to the wrong modal in the DOM (not necessarily the one belonging to
    // the clicked card), producing QA's reported "Edit briefly shows the
    // clicked image, then switches to the previous one" flicker. This id,
    // paired with the matching computed in PhotoEditor, gives every card a
    // unique modal id so the Edit button always opens its own editor.
    modalTargetId() {
      return this.image && this.image.id
        ? `image-editor-${this.image.id}`
        : "image-editor";
    },
  },
  methods: {
    downloadImage(image) {
      axios
        .get(image.BlobImageUrl, {
          responseType: "blob",
        })
        .then((response) => {
          if (response) {
            var FileSaver = require("file-saver");
            FileSaver.saveAs(
              new Blob([response.data]),
              image.StockNumber + ".jpg"
            );
          }
        });
      },

    displayCroppedImage(image) {
      if (image) {
        this.croppedImage = image;
      }
    },
      selectImage(image) {
      // Toggle the local visual state alongside emitting the toggle event.
      // Without this, the checkbox is bound `:checked="isChecked"` but a user
      // click never updates isChecked — Vue re-renders and snaps the
      // checkbox back to its previous state, so individual deselects after
      // "Select All" appeared not to work and the parent's `selected` array
      // could end up out of sync with what the user saw.
      this.isChecked = !this.isChecked;
      this.$emit("updateSelectedImage", image);
    },
    deleteImage(image) {
      this.$emit("deleteSelectedImage", image);
    },
    restoreImage(image) {
      this.$emit("restoreArchivedImage", image);
    },
  },
  watch: {
    selectedMachine: {
      handler: function () {
        return this.selectedMachine && this.selectedMachine.StockNumber
          ? this.selectedMachine.StockNumber
          : this.image.StockNumber;
      },
    },
    showModal: {
      handler: function () {
        this.$emit("disableDraggableCards", this.showModal);
      }            
      },
    
      
  },
};
</script>
<style scoped>
    a.disabled {
        pointer-events: none !important;
        cursor: default !important;
    }

    /*
     * Bug #52 fix: tighten the contrast between enabled (black) and disabled (grey)
     * action buttons. Bootstrap's .text-dark resolves to #212529, which is hard to
     * distinguish from .text-muted (#6c757d) at small sizes. Force a true black on
     * enabled actions and a lighter grey on disabled ones so the states are clearly
     * different at a glance.
     */
    .btn-link.text-dark {
        color: #000 !important;
    }
    .btn-link.text-muted {
        color: #adb5bd !important;
    }
</style>